module.exports = __webpack_public_path__ + "img/logo-name.86b37a0f.webp";